import React from "react";
import {observer} from "mobx-react";
import {fieldStyles} from "core/form/createForm";
import {MdTextField} from "core/components/fields/fields";
import {EditorState} from "draft-js";
import {debounce} from "core/common/utils/utils";
import {computeHeight} from "core/common/utils/domUtils";
import gridService from "core/grid/gridService";

interface SqlSelectEditorProps {
  onChange: (e: EditorState) => void;
  sqlCommand: string;
  style?: any;
}

let AceEditor;

interface SqlSelectEditorState {
  aceHeightBody: number;
}

@observer
export default class SqlSelectEditor extends React.Component<SqlSelectEditorProps, SqlSelectEditorState> {


  state = {
    aceHeightBody: 400
  };

  onResizeDebounced: any;

  _aceEditorBody: React.ReactInstance;


  componentWillMount() {
    require.ensure(['react-ace', 'brace', 'brace/mode/sql', 'brace/theme/github', 'brace/ext/searchbox'], (require) => {
      if (AceEditor) {
        return;
      }

      AceEditor = (require('react-ace') as any).default;
      const brace = require("brace");
      require('brace/mode/sql');
      require('brace/theme/github');
      require('brace/ext/searchbox');


      this.forceUpdate();
      this.onResize();

    }, "reactAce");
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    this.onResizeDebounced = debounce(this.onResize, 15, false);
    window.addEventListener('resize', this.onResizeDebounced);
    this.onResize();
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeDebounced);
  }


  onResize = (evt?) => {
    let bodyRect = document.body.getBoundingClientRect();

    let aceHeightBody = computeHeight(bodyRect, this._aceEditorBody);

    console.debug("onResize: " + aceHeightBody);

    if (aceHeightBody) {
      this.setState({aceHeightBody: aceHeightBody});
    }
  };


  render() {
    let {onChange, sqlCommand} = this.props;

    return (
      (AceEditor) ?
        <AceEditor
          mode="sql"
          theme="github"
          value={sqlCommand}
          onChange={onChange}
          name="SQL"
          enableBasicAutocompletion={true}
          enableLiveAutocompletion={true}
          editorProps={{$blockScrolling: true}}
          width="100%"
          height={this.state.aceHeightBody + 'px'}
          style={{padding: '5px 0 0 0'}}
          ref={(c) => this._aceEditorBody = c}
        />
        : <div>Loading....</div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/core/components/editors/sqlSelectEditor.tsx